export const SET_COLLECTIONS = (state, payload) => {
  state.collections = payload;
}

export const SET_COLLECTION = (state, payload) => {
  state.collection = payload;
}

export const SET_TEMPLATES = (state, payload) => {
  state.templates = payload
}
